import { useQuery } from "@tanstack/react-query";

// Simple portfolio items query hook for backward compatibility
export function usePortfolioItemsQuery(profileId?: string) {
  return useQuery({
    queryKey: ["portfolioItems", profileId],
    queryFn: async () => {
      // Placeholder implementation - return empty array for now
      // In a real implementation, this would fetch from the API
      return [];
    },
    enabled: !!profileId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    select: (data) => data || [], // Ensure we always return an array
  });
}
